import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import ReactGA from "react-ga";
import "./assets/themes/custom/npamedicare/css/bootstrap.min.css";
import "./assets/themes/custom/npamedicare/css/style.css";
import "./assets/themes/custom/npamedicare/css/npasellsheet.css";
import "./assets/themes/custom/npamedicare/css/bootstrap.css";
import "./assets/themes/custom/npamedicare/css/datepicker.css";
import ScrollToTop from "./components/Common/ScrollToTop";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import PaymentChange from "./components/Change/PaymentChange";

// import MBRxChange2022WithRouter from "./components/Change/2022/MbrxChange2022";
// import MBRxChange2023WithRouter from "./components/Change/2023/MbrxChange2023";
//import MBRxChange2024WithRouter from "./components/Change/2024/MbrxChange2024";
//import MBRxChange2025WithRouter from "./components/Change/2025/MbrxChange2025";
import DemographicChange from "./components/Change/DemographicChange";
import AboutStarRatings from "./components/Compare/AboutStarRatings";
import ComparePlans from "./components/Compare/ComparePlans";
import OtherMedicarePlans from "./components/Compare/OtherMedicarePlans";
// import PlanCompare2022 from "./components/Compare/PlanCompare2022";
// import PlanCompare2023 from "./components/Compare/PlanCompare2023";
//import PlanCompare2024 from "./components/Compare/PlanCompare2024";
//import PlanCompare2025 from "./components/Compare/PlanCompare2025";
import PlanCompare2026 from "./components/Compare/PlanCompare2026";
import PlanCompare2027 from "./components/Compare/PlanCompare2027";


import ContactEMTMHealthCarePro from "./components/Contact/ContactEMTMHealthCarePro";
import ContactUs from "./components/Contact/ContactUs";
import Contact from "./components/Contact/Contact";
import ContactConfirmation from "./components/Contact/ContactConfirmation";
import Covid19 from "./components/Covid/Covid19";
import IndividualPlanDocs2027 from "./components/Documents/IndividualPlanDocs2027";
import IndividualPlanDocs2026 from "./components/Documents/IndividualPlanDocs2026";
import IndividualPlanDocs2025 from "./components/Documents/IndividualPlanDocs2025";
//import IndividualPlanDocs2024 from "./components/Documents/IndividualPlanDocs2024";
// import IndividualPlanDocs2023 from "./components/Documents/IndividualPlanDocs2023";
import IndividualPlanDocs2022 from "./components/Documents/IndividualPlanDocs2022";
import IndividualPlanDocs2021 from "./components/Documents/IndividualPlanDocs2021";
import DrugPricingTool2022 from "./components/DrugPricingTool/DrugPricingTool2022";
import DrugPricingTool2021 from "./components/DrugPricingTool/DrugPricingTool2021";
import EmployerGroupDocs2027 from "./components/EmployerGroupPlans/EmployerGroupDocs2027";
import EmployerGroupDocs2026 from "./components/EmployerGroupPlans/EmployerGroupDocs2026";
import EmployerGroupDocs2025 from "./components/EmployerGroupPlans/EmployerGroupDocs2025";
//import EmployerGroupDocs2024 from "./components/EmployerGroupPlans/EmployerGroupDocs2024";
// import EmployerGroupDocs2023 from "./components/EmployerGroupPlans/EmployerGroupDocs2023";
import EmployerGroupDocs2022 from "./components/EmployerGroupPlans/EmployerGroupDocs2022";
import EmployerGroupDocs2021 from "./components/EmployerGroupPlans/EmployerGroupDocs2021";
import FWA from "./components/EmployerGroupPlans/FWA";
import GroupContactInfo from "./components/EmployerGroupPlans/GroupContactInfo";
import GroupCommunicationTimeline from "./components/EmployerGroupPlans/GroupCommunicationTimeline";
import GroupPlanResearchTools from "./components/EmployerGroupPlans/GroupPlanResearchTools";
import GroupResources from "./components/EmployerGroupPlans/GroupResources";
import PartDPlansEmployerAndUnionGroups from "./components/EmployerGroupPlans/PartDPlansEmployerAndUnionGroups";

// import ChangePlan2022 from "./components/Enroll/2022/ChangePlan2022";
// import ChangePlan2023 from "./components/Enroll/2023/ChangePlan2023";
//import ChangePlan2024 from "./components/Enroll/2024/ChangePlan2024";
//import ChangePlan2025 from "./components/Enroll/2025/ChangePlan2025";

//import S5743NoticeOfRightsPreEnroll508 from "./components/Files/S5743NoticeOfRightsPreEnroll508";
import GroupBenefits from "./components/EmployerGroupPlans/GroupBenefits";
import GroupPlanManagement from "./components/GroupPlanManagement/GroupPlanManagement";
import MedicareBlueFWA from "./components/Learn/MedicareBlueFWA";
import CoverageDeterminations from "./components/Members/CoverageDeterminations";
import DrugClaims from "./components/Members/DrugClaims";
import DrugInfo from "./components/Members/DrugInfo";
import RightsAndResponsibilities from "./components/Members/RightsAndResponsibilities";
import EMTMProviders from "./components/Members/EMTMProviders";
import EMTMProgram from "./components/Members/EMTMProgram";
import MailOrderPrescriptions from "./components/Members/MailOrderPrescriptions";
import MedicationTherapyManagementProgram from "./components/Members/MedicationTherapyManagementProgram";
import MemberDiscounts from "./components/Members/MemberDiscounts";
import Members from "./components/Members/Members";
import OrderMemberIdCard from "./components/Members/OrderMemberIdCard";
import PaymentInfo from "./components/Members/PaymentInfo";
import PharmacyInfo from "./components/Members/PharmacyInfo";
import PlanTransitionSupply from "./components/Members/PlanTransitionSupply";
import SubmitClaim from "./components/Members/SubmitClaim";
import CommunicationTimeline from "./components/PartDBasics/CommunicationTimeline";
import MedicarePrescriptionPaymentPlan from "./components/PartDBasics/MedicarePrescriptionPaymentPlan";
import EligibilityRequirements from "./components/PartDBasics/EligibilityRequirements";
import FAQ from "./components/PartDBasics/FAQ";
import FinancialAssistance from "./components/PartDBasics/FinancialAssistance";
import Glossary from "./components/PartDBasics/Glossary";
import PartDBasics from "./components/PartDBasics/PartDBasics";
import WhenToEnroll from "./components/PartDBasics/WhenToEnroll";
import FindMyPharmacyGroup2022 from "./components/Pharmacy/FindMyPharmacyGroup2022";
import FindMyPharmacyPremier2022 from "./components/Pharmacy/FindMyPharmacyPremier2022";
import FindMyPharmacyPremier2021 from "./components/Pharmacy/FindMyPharmacyPremier2021";
import FindMyPharmacyStandard2022 from "./components/Pharmacy/FindMyPharmacyStandard2022";
import FindMyPharmacyStandard2021 from "./components/Pharmacy/FindMyPharmacyStandard2021";
import FindMyPharmacyGroup2021 from "./components/Pharmacy/FindMyPharmacyGroup2021";
import PharmacyTools from "./components/Pharmacy/PharmacyTools";
import PrivacyPolicy from "./components/PrivacyTerms/PrivacyPolicy";
import TermsOfUse from "./components/PrivacyTerms/TermsOfUse";
import Header from "./components/Common/Header";
import Footer from "./components/Common/Footer";
import {
  StateMachineProvider,
  createStore,
  useStateMachine,
} from "little-state-machine";

import enrollData from "./state/data/enrollData";
import Enroll from "./components/Enroll/Enroll";

import validationData from "./state/data/validationData";

// import EnrollNow2022 from "./components/Enroll/2022/EnrollNow2022";
// import EnrollNow2023 from "./components/Enroll/2023/EnrollNow2023";
//import EnrollNow2024 from "./components/Enroll/2024/EnrollNow2024";
//import EnrollNow2025 from "./components/Enroll/2025/EnrollNow2025";
import EnrollNow2026 from "./components/Enroll/2026/EnrollNow2026";
import EnrollNow2027 from "./components/Enroll/2027/EnrollNow2027";

// import MBRx2022WithRouter from "./components/Enroll/2022/MBRxEnroll2022";
// import MBRx2023WithRouter from "./components/Enroll/2023/MBRxEnroll2023";
//import MBRx2024WithRouter from "./components/Enroll/2024/MBRxEnroll2024";
//import MBRx2025WithRouter from "./components/Enroll/2025/MBRxEnroll2025";
import MBRx2026 from "./components/Enroll/2026/MBRxEnroll2026";
import MBRx2027 from "./components/Enroll/2027/MBRxEnroll2027";

import PageNotFound from "./components/PageNotFound";

import BackToTop from "./components/Common/BackToTop";
import SearchResultsList from "./components/Search/SearchResultsList";

import ExternalLinkHandler from "./components/Common/ExternalLinkHandler";
import AgentPortal from "./components/Common/AgentPortal";

import updateValidationData from "./state/actions/updateValidationData";

import MemberDocuments from "./components/Members/MemberDocuments";

import GroupPlanContactInfo from "./components/GroupPlanManagement/GroupPlanContactInfo";
import GroupImplementation from "./components/GroupPlanManagement/GroupImplementation";
import GroupLogin from "./components/GroupPlanManagement/GroupLogin";
import GroupDashboard from "./components/GroupPlanManagement/GroupDashboard";
import GroupRenewal from "./components/GroupPlanManagement/GroupRenewal";
import GroupTermination from "./components/GroupPlanManagement/GroupTermination";

import ReactGA4 from "react-ga4";
import GroupMaterials from "./components/EmployerGroupPlans/GroupMaterials";

import ClearStoneHub from "./components/ClearStoneHub/ClearStoneHub";
import CSHUser from "./components/ClearStoneHub/CSHUser";
import CSHUsers from "./components/ClearStoneHub/CSHUsers";

export default function App() {
  //ReactGA.initialize("UA-31493464-1");
  ReactGA4.initialize(process.env.REACT_APP_GA_ID);

  createStore({
    enrollData,
    validationData,
  });

  function resizeText(multiplier) {
    if (document.body.style.fontSize === "") {
      document.body.style.fontSize = "18px";
    }
    switch (multiplier) {
      case 1:
        document.body.style.fontSize = "18px";
        break;
      case 1.5:
        document.body.style.fontSize = "24px";
        break;
      case 2:
        document.body.style.fontSize = "36px";
        break;
      default:
        document.body.style.fontSize = "18px";
        break;
    }
    // document.body.style.fontSize =
    //   parseFloat(document.body.style.fontSize) + multiplier * 1.0 + "em";
  }

  // const [displayBankValidationMessage, setDisplayBankValidationMessage] =
  //   useState(false);
  // const [disableEFTOption, setDisableEFTOption] = useState(false);
  // const [counter, setCounter] = useState(1);

  // const { state, actions } = useStateMachine({
  //   updateValidationData
  // });

  // // reset validationCounter to 0 on application load
  // useEffect(() => () => {
  //     actions.updateValidationData({ validationCounter: 0 });
  //   },[]);

  return (
    <StateMachineProvider>
      <Router>
        <ScrollToTop />
        <div
          style={{
            maxWidth: "1400px", // or your preferred width
            margin: "0 auto",
            background: "#fff",
            minHeight: "100vh",
          }}
        >
          <Header
            resizeText={resizeText}
          // handleSearch={handleSearch}
          // searchResults={searchResults}
          // isLoading={isLoading}
          />

          <Routes>

            <Route path="/" element={<Home />} />
            <Route path="/index.html" element={<Navigate to="/" replace />} />
            <Route path="/About" element={<About />} />

            <Route path="/ClearStoneHub" element={<ClearStoneHub />} />
            <Route path="/ClearStoneHub/:id?" element={<ClearStoneHub />} />
            <Route path="/ClearStoneHub/Users" element={<CSHUsers />} />
            <Route path="/ClearStoneHub/Users/:id" element={<CSHUser />} />
            <Route path="/ClearStoneHub/Users" element={<CSHUsers />} />

            <Route path="/mbrx-change-payment-option" element={<PaymentChange />} />
            <Route path="/ChangePayment" element={<PaymentChange />} />
            <Route path="/change-payment-option" element={<PaymentChange />} />
            {/* <Route path="/Change/MBRxChange2021" element={<MBRxChange2021 />} /> */}
            {/* <Route
            path="/Change/MBRxChange2022"
            exact
            component={() => (
              <MBRxChange2022WithRouter
                counter={counter}
                setCounter={setCounter}
                displayBankValidationMessage={displayBankValidationMessage}
                setDisplayBankValidationMessage={
                  setDisplayBankValidationMessage
                }
                disableEFTOption={disableEFTOption}
                setDisableEFTOption={setDisableEFTOption}
              />
            )}
          /> */}
            {/* <Route
            path="/Change/MBRxChange2022"
            exact
            component={() => (
              <MBRxChange2024WithRouter
                // counter={counter}
                // setCounter={setCounter}
                // displayBankValidationMessage={displayBankValidationMessage}
                // setDisplayBankValidationMessage={
                //   setDisplayBankValidationMessage
                // }
                // disableEFTOption={disableEFTOption}
                // setDisableEFTOption={setDisableEFTOption}
              />
            )}
          /> */}
            {/* <Route
            path="/Change/MBRxChange2023"
            exact
            component={() => (
              <MBRxChange2024WithRouter
                // counter={counter}
                // setCounter={setCounter}
                // displayBankValidationMessage={displayBankValidationMessage}
                // setDisplayBankValidationMessage={
                //   setDisplayBankValidationMessage
                // }
                // disableEFTOption={disableEFTOption}
                // setDisableEFTOption={setDisableEFTOption}
              />
            )}
          /> */}
            {/* <Route
            path="/Change/MBRxChange2024"
            exact
            component={() => (
              <MBRxChange2024WithRouter
                // counter={counter}
                // setCounter={setCounter}
                // displayBankValidationMessage={displayBankValidationMessage}
                // setDisplayBankValidationMessage={
                //   setDisplayBankValidationMessage
                // }
                // disableEFTOption={disableEFTOption}
                // setDisableEFTOption={setDisableEFTOption}
              />
            )}
          /> */}
            <Route path="/Change/MBRxChange2025" element={<Navigate to="/enroll/2026-enroll-now" replace />} />
            <Route path="/Change/MBRxChange2023" element={<Navigate to="/Change/MBRxChange2025" replace />} />
            <Route path="/Change/MBRxChange2023" element={<Navigate to="/Change/MBRxChange2025" replace />} />
            <Route path="/Change/MBRxChange2024" element={<Navigate to="/Change/MBRxChange2025" replace />} />
            {/* <Route
              path="/Change/MBRxChange2025"
              exact
              component={() => (
                <MBRxChange2025WithRouter
                // counter={counter}
                // setCounter={setCounter}
                // displayBankValidationMessage={displayBankValidationMessage}
                // setDisplayBankValidationMessage={
                //   setDisplayBankValidationMessage
                // }
                // disableEFTOption={disableEFTOption}
                // setDisableEFTOption={setDisableEFTOption}
                />
              )}
            /> */}
            <Route path="/mbrx-update-contact-information" element={<DemographicChange />} />
            <Route path="/UpdateContact" element={<DemographicChange />} />
            <Route path="/compare-plans/about-star-ratings" element={<AboutStarRatings />} />
            <Route path="/StarRatings" element={<AboutStarRatings />} />
            <Route path="/compare-plans" element={<ComparePlans />} />
            <Route path="/Compare" element={<ComparePlans />} />
            <Route path="/Compare/OtherMedicarePlans" element={<OtherMedicarePlans />} />
            <Route path="/Compare/PlanCompare2026" element={<PlanCompare2026 />} />
            <Route path="/Compare/PlanInformation2027" element={<PlanCompare2027 />} />
            {/* <Route path="/Compare/PlanCompare2025" element={<PlanCompare2025 />} /> */}
            <Route path="/Compare/PlanCompare2025" element={<Navigate to="/Compare/PlanCompare2026" replace />} />
            <Route path="/Compare/PlanCompare2024" element={<Navigate to="/Compare/PlanCompare2025" replace />} />
            {/* <Route path="/Compare/PlanCompare2024" element={<PlanCompare2024 />} /> */}
            <Route path="/Compare/PlanCompare2023" element={<Navigate to="/Compare/PlanCompare2024" replace />} />
            {/* <Route path="/Compare/PlanCompare2023" element={<PlanCompare2024 />} /> */}
            <Route path="/Compare/PlanCompare2022" element={<Navigate to="/Compare/PlanCompare2023" replace />} />
            {/* <Route path="/Compare/PlanCompare2022" element={<PlanCompare2023 />} /> */}
            {/* <Route path="/Compare/PlanCompare2022" element={<PlanCompare2022 />} /> */}
            {/* <Route path="/Compare/PlanCompare2021" element={<PlanCompare2021 />} /> */}
            <Route path="/Contact/ContactEMTMHealthCarePro" element={<ContactEMTMHealthCarePro />} />
            <Route path="/Contact/contact-form-online" element={<ContactUs />} />
            <Route path="/group-materials" element={<GroupMaterials />} />

            <Route path="/contact-confirmation" element={<ContactConfirmation />} />
            <Route path="/contact/medicareblue-rx" element={<Contact />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/Covid/Covid19" element={<Covid19 />} />
            <Route path="/Covid" element={<Covid19 />} />

            <Route path="/2027Documents" element={<IndividualPlanDocs2027 />} />
            <Route path="/2026Documents" element={<IndividualPlanDocs2026 />} />
            {/* <Route path="/2025Documents" element={<IndividualPlanDocs2025 />} /> */}
            <Route path="/2025Documents" element={<Navigate to="/2026Documents" replace />} />
            <Route path="/2024Documents" element={<Navigate to="/2025Documents" replace />} />
            {/* <Route path="/2024Documents" element={<IndividualPlanDocs2024 />} /> */}
            <Route path="/Documents/IndividualPlanDocs2027" element={<IndividualPlanDocs2027 />} />
            <Route path="/Documents/IndividualPlanDocs2026" element={<IndividualPlanDocs2026 />} />
            <Route path="/Documents/IndividualPlanDocs2025" element={<IndividualPlanDocs2025 />} />
            {/* <Route path="/Documents/IndividualPlanDocs2025" element={<Navigate to="/Documents/IndividualPlanDocs2026" replace />} /> */}
            <Route path="/Documents/IndividualPlanDocs2024" element={<Navigate to="/Documents/IndividualPlanDocs2025" replace />} />
            {/* <Route path="/Documents/IndividualPlanDocs2024" element={<IndividualPlanDocs2024 />} /> */}

            <Route path="/2023Documents" element={<Navigate to="/2024Documents" replace />} />
            {/* <Route path="/2023Documents" element={<IndividualPlanDocs2023 />} /> */}

            <Route path="/Documents/IndividualPlanDocs2023" element={<Navigate to="/Documents/IndividualPlanDocs2024" replace />} />
            {/* <Route path="/Documents/IndividualPlanDocs2023" element={<IndividualPlanDocs2023 />} /> */}

            <Route path="/Documents/IndividualPlanDocs2022" element={<Navigate to="/Documents/IndividualPlanDocs2023" replace />} />
            {/* <Route path="/Documents/IndividualPlanDocs2022" element={<IndividualPlanDocs2022 />} /> */}
            <Route path="/Documents" element={<IndividualPlanDocs2026 />} />
            {/* <Route path="/Documents" element={<IndividualPlanDocs2026 />} /> */}
            {/* <Route path="/Documents/IndividualPlanDocs2021" element={<IndividualPlanDocs2021 />} /> */}
            {/* <Route path="/DrugPricingTool/DrugPricingTool2022" element={<Navigate to="/pharmacy-tools-landing" replace />} /> */}
            {/* <Route
            path="/DrugPricingTool/DrugPricingTool2022"
            exact
            component={PharmacyTools}
            // component={DrugPricingTool2022}  // 12/31/22 Redirect 2022 Drug Pricing to PharmacyTools
          /> */}
            {/* <Route path="/DrugPricingTool/DrugPricingTool2021" element={<DrugPricingTool2021 />} /> */}
            <Route path="/EmployerGroupPlans/EmployerGroupDocs2027" element={<EmployerGroupDocs2027 />} />
            <Route path="/EmployerGroupPlans/EmployerGroupDocs2026" element={<EmployerGroupDocs2026 />} />
            <Route path="/EmployerGroupPlans/EmployerGroupDocs2025" element={<EmployerGroupDocs2025 />} />
            {/*<Route path="/EmployerGroupPlans/EmployerGroupDocs2025" element={<Navigate to="/EmployerGroupPlans/EmployerGroupDocs2026" replace />} />*/}
            <Route path="/EmployerGroupPlans/EmployerGroupDocs2024" element={<Navigate to="/EmployerGroupPlans/EmployerGroupDocs2025" replace />} />
            {/* <Route path="/EmployerGroupPlans/EmployerGroupDocs2024" element={<EmployerGroupDocs2024 />} /> */}

            <Route path="/EmployerGroupPlans/EmployerGroupDocs2023" element={<Navigate to="/EmployerGroupPlans/EmployerGroupDocs2024" replace />} />
            {/* <Route path="/EmployerGroupPlans/EmployerGroupDocs2023" element={<EmployerGroupDocs2023 />} /> */}

            <Route path="/EmployerGroupPlans/EmployerGroupDocs2022" element={<Navigate to="/EmployerGroupPlans/EmployerGroupDocs2023" replace />} />
            {/* <Route path="/EmployerGroupPlans/EmployerGroupDocs2022" element={<EmployerGroupDocs2022 />} /> */}

            <Route path="/2025GroupDocuments" element={<Navigate to="/2026GroupDocuments" replace />} />
            <Route path="/2024GroupDocuments" element={<Navigate to="/2025GroupDocuments" replace />} />
            <Route path="/2023GroupDocuments" element={<Navigate to="/2024GroupDocuments" replace />} />
            {/* <Route path="/2023GroupDocuments" element={<EmployerGroupDocs2023 />} /> */}

            <Route path="/2027GroupDocuments" element={<EmployerGroupDocs2027 />} />
            <Route path="/2026GroupDocuments" element={<EmployerGroupDocs2026 />} />
            {/* <Route path="/2025GroupDocuments" element={<EmployerGroupDocs2025 />} /> */}
            {/* <Route path="/2024GroupDocuments" element={<EmployerGroupDocs2024 />} /> */}

            <Route path="/GroupDocuments" element={<EmployerGroupDocs2026 />} />
            {/* <Route path="/GroupDocuments" element={<EmployerGroupDocs2026 />} /> */}
            {/* <Route path="/GroupDocuments" element={<EmployerGroupDocs2022 />} /> */}
            {/* <Route path="/EmployerGroupPlans/EmployerGroupDocs2021" element={<EmployerGroupDocs2021 />} /> */}
            <Route path="/EmployerGroupPlans/FWA" element={<FWA />} />
            <Route path="/employer-group-plans/group-contact-information" element={<GroupContactInfo />} />
            <Route path="/EmployerGroupPlans/GroupCommunicationTimeline" element={<GroupCommunicationTimeline />} />
            <Route path="/GroupContact" element={<GroupContactInfo />} />
            <Route path="/EmployerGroupPlans/GroupPlanResearchTools" element={<GroupPlanResearchTools />} />
            <Route path="/GroupPharmacy" element={<GroupPlanResearchTools />} />
            <Route path="/EmployerGroupPlans/GroupResources" element={<GroupResources />} />
            <Route path="/EmployerGroupPlans/PartDPlansEmployerAndUnionGroups" element={<PartDPlansEmployerAndUnionGroups />} />
            {/* <Route path="/Enroll/2021-change-plan" element={<ChangePlan2021 />} /> */}
            {/* <Route path="/Enroll/2022-change-plan" element={<ChangePlan2022 />} /> */}
            {/* <Route path="/Enroll/2022-change-plan" element={<Navigate to="/Enroll/2025-change-plan" replace />} /> */}
            {/* <Route path="/Enroll/2022-change-plan" element={<ChangePlan2023 />} /> */}
            <Route path="/Enroll/2023-change-plan" element={<Navigate to="/Enroll/2025-change-plan" replace />} />
            <Route path="/Enroll/2024-change-plan" element={<Navigate to="/Enroll/2025-change-plan" replace />} />
            <Route path="/Enroll/2025-change-plan" element={<Navigate to="/Enroll/2026-enroll-now" replace />} />
            {/* <Route path="/Enroll/2023-change-plan" element={<ChangePlan2024 />} /> */}
            {/* <Route path="/Enroll/2025-change-plan" element={<ChangePlan2025 />} /> */}
            {/* <Route path="/Enroll/2024-change-plan" element={<ChangePlan2024 />} /> */}

            {/* <Route path="/Files/S5743NoticeOfRightsPreEnroll508" element={<S5743NoticeOfRightsPreEnroll508 />} /> */}
            <Route path="/GroupBenefits" element={<GroupBenefits />} />
            <Route path="/GroupPlans" element={<GroupBenefits />} />
            <Route path="/Learn/MedicareBlueFWA" element={<MedicareBlueFWA />} />
            <Route path="/Members/coverage-determinations" element={<CoverageDeterminations />} />
            <Route path="/Members/DrugClaims" element={<DrugClaims />} />
            <Route path="/Members/drug-information" element={<DrugInfo />} />
            <Route path="/Members/emtm-program" element={<EMTMProgram />} />
            <Route path="/Members/emtm-providers" element={<EMTMProviders />} />
            <Route path="/Members/MailOrderPrescriptions" element={<MailOrderPrescriptions />} />
            <Route path="/Members/medication-therapy-management-program" element={<MedicationTherapyManagementProgram />} />
            <Route path="/Members/rights-and-responsibilities" element={<RightsAndResponsibilities />} />
            <Route path="/MTM" element={<MedicationTherapyManagementProgram />} />
            <Route path="/Members/MemberDiscounts" element={<MemberDiscounts />} />
            <Route path="/Members" element={<Members />} />
            <Route path="/Members/OrderMemberIdCard" element={<OrderMemberIdCard />} />
            <Route path="/Members/PaymentInfo" element={<PaymentInfo />} />
            <Route path="/Members/PharmacyInfo" element={<PharmacyInfo />} />
            <Route path="/Members/PlanTransitionSupply" element={<PlanTransitionSupply />} />
            <Route path="/Members/SubmitClaim" element={<SubmitClaim />} />
            <Route path="/PartDBasics/CommunicationTimeline" element={<CommunicationTimeline />} />
            <Route path="/PartDBasics/MedicarePrescriptionPaymentPlan" element={<MedicarePrescriptionPaymentPlan />} />
            <Route path="/PartDBasics/EligibilityRequirements" element={<EligibilityRequirements />} />
            <Route path="/part-d-basics/frequently-asked-questions" element={<FAQ />} />
            <Route path="/PartDBasics/FinancialAssistance" element={<FinancialAssistance />} />
            <Route path="/PartDBasics/Glossary" element={<Glossary />} />
            <Route path="/PartDBasics" element={<PartDBasics />} />
            <Route path="/PartDBasics/WhenToEnroll" element={<WhenToEnroll />} />
            <Route path="/GroupPharmacy2022" element={<FindMyPharmacyGroup2022 />} />
            <Route path="/Pharmacy/FindMyPharmacyPremier2022" element={<Navigate to="/pharmacy-tools-landing" replace />} />
            {/* <Route path="/Pharmacy/FindMyPharmacyPremier2022" element={<FindMyPharmacyPremier2022 />} /> */}
            <Route path="/Pharmacy/FindMyPharmacyPremier2021" element={<FindMyPharmacyPremier2021 />} />
            <Route path="/Pharmacy/FindMyPharmacyStandard2022" element={<Navigate to="/pharmacy-tools-landing" replace />} />
            {/* <Route path="/Pharmacy/FindMyPharmacyStandard2022" element={<FindMyPharmacyStandard2022 />} /> */}
            <Route path="/Pharmacy/FindMyPharmacyStandard2021" element={<FindMyPharmacyStandard2021 />} />
            <Route path="/GroupPharmacy2021" element={<FindMyPharmacyGroup2021 />} />
            <Route path="/pharmacy-tools-landing" element={<PharmacyTools />} />
            <Route path="/PharmacyTools" element={<PharmacyTools />} />
            <Route path="/PlanTools" element={<PharmacyTools />} />
            <Route path="/Drugs" element={<PharmacyTools />} />
            <Route path="/Pharmacy" element={<PharmacyTools />} />
            <Route path="/Privacy" element={<PrivacyPolicy />} />
            <Route path="/TermsOfUse" element={<TermsOfUse />} />
            <Route path="/enroll-0" element={<Enroll />} />
            {/* <Route path="/enroll/2021-enroll-now" element={<EnrollNow2021 />} />
          <Route path="/mbrx-enroll-2021" element={<MBRx2021 />} /> */}

            {/* <Route path="/enroll/2022-enroll-now" element={<EnrollNow2022 />} /> */}
            {/* <Route path="/enroll/2022-enroll-now" element={<Navigate to="/enroll/2025-enroll-now" replace />} /> */}
            {/* <Route path="/enroll/2022-enroll-now" element={<EnrollNow2023 />} /> */}
            <Route path="/enroll/2023-enroll-now" element={<Navigate to="/enroll/2025-enroll-now" replace />} />
            <Route path="/enroll/2024-enroll-now" element={<Navigate to="/enroll/2025-enroll-now" replace />} />
            <Route path="/enroll/2025-enroll-now" element={<Navigate to="/enroll/2026-enroll-now" replace />} />
            {/* <Route path="/enroll/2023-enroll-now" element={<EnrollNow2024 />} /> */}
            {/* <Route path="/enroll/2025-enroll-now" element={<EnrollNow2025 />} /> */}
            <Route path="/enroll/2026-enroll-now" element={<EnrollNow2026 />} />
            <Route path="/enroll/2027-enroll-now" element={<EnrollNow2027 />} />
            {/* <Route path="/enroll/2024-enroll-now" element={<EnrollNow2024 />} /> */}

            {/* <Route
            path="/mbrx-enroll-2022"
            exact
            component={() => (
              <MBRx2022WithRouter
                counter={counter}
                setCounter={setCounter}
                displayBankValidationMessage={displayBankValidationMessage}
                setDisplayBankValidationMessage={
                  setDisplayBankValidationMessage
                }
                disableEFTOption={disableEFTOption}
                setDisableEFTOption={setDisableEFTOption}
              />
            )}
          /> */}
            {/* <Route
            path="/mbrx-enroll-2022"
            exact
            component={() => (
              <MBRx2025WithRouter
                // counter={counter}
                // setCounter={setCounter}
                // displayBankValidationMessage={displayBankValidationMessage}
                // setDisplayBankValidationMessage={
                //   setDisplayBankValidationMessage
                // }
                // disableEFTOption={disableEFTOption}
                // setDisableEFTOption={setDisableEFTOption}
              />
            )}
          /> */}
            {/* <Route
            path="/mbrx-enroll-2023"
            exact
            component={() => (
              <MBRx2025WithRouter
                // counter={counter}
                // setCounter={setCounter}
                // displayBankValidationMessage={displayBankValidationMessage}
                // setDisplayBankValidationMessage={
                //   setDisplayBankValidationMessage
                // }
                // disableEFTOption={disableEFTOption}
                // setDisableEFTOption={setDisableEFTOption}
              />
            )}
          /> */}
            <Route
              path="/mbrx-enroll-2027"
              element={<MBRx2027 />}
            />
            <Route
              path="/mbrx-enroll-2026"
              element={<MBRx2026 />}
            />
            {/* <Route
              path="/mbrx-enroll-2025"
              exact
              component={() => (
                <MBRx2025WithRouter
                // counter={counter}
                // setCounter={setCounter}
                // displayBankValidationMessage={displayBankValidationMessage}
                // setDisplayBankValidationMessage={
                //   setDisplayBankValidationMessage
                // }
                // disableEFTOption={disableEFTOption}
                // setDisableEFTOption={setDisableEFTOption}
                />
              )}
            /> */}
            {/* <Route path="/mbrx-enroll-2022" element={<Navigate to="/mbrx-enroll-2025" replace />} /> */}
            <Route path="/mbrx-enroll-2023" element={<Navigate to="/mbrx-enroll-2025" replace />} />
            <Route path="/mbrx-enroll-2024" element={<Navigate to="/mbrx-enroll-2025" replace />} />
            <Route path="/mbrx-enroll-2025" element={<Navigate to="/mbrx-enroll-2026" replace />} />
            {/* <Route
            path="/mbrx-enroll-2024"
            exact
            component={() => (
              <MBRx2024WithRouter
                // counter={counter}
                // setCounter={setCounter}
                // displayBankValidationMessage={displayBankValidationMessage}
                // setDisplayBankValidationMessage={
                //   setDisplayBankValidationMessage
                // }
                // disableEFTOption={disableEFTOption}
                // setDisableEFTOption={setDisableEFTOption}
              />
            )}
          /> */}
            <Route path="/AgentPortal" element={<AgentPortal />} />
            <Route path="/search" element={<SearchResultsList />} />
            <Route path="/MemberDocuments" element={<MemberDocuments />} />
            <Route path="/GroupPlanManagement" element={<GroupPlanManagement />} />
            <Route path="/GroupImplementation" element={<GroupImplementation />} />
            <Route path="/GroupPlanContactInfo" element={<GroupPlanContactInfo />} />
            <Route path="/GroupLogin" element={<GroupLogin />} />
            <Route path="/GroupDashboard" element={<GroupDashboard />} />
            <Route path="/GroupRenewal" element={<GroupRenewal />} />
            <Route path="/GroupTermination" element={<GroupTermination />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
          <Footer />
          <ExternalLinkHandler />
        </div>
      </Router>
      <BackToTop />
    </StateMachineProvider>
  );
}
